<div class="home-page-wrapper d-none d-lg-block">
  <div class="home-page-head">
    <span class="welcome-title" data-testid="welcome-title">
      Welcome back,&nbsp;
      <strong data-testid="user-name">{{ userObj.firstName + ' ' + userObj.lastName }}</strong>
    </span>
  </div>
  <div class="home-page-content">
    <div class="apps-section mb-5" *ngIf="userApps.length" data-testid="apps-section">
      <h6 data-testid="your-apps-title">Your Apps</h6>
      <div class="row apps-wrapper">
        <div class="col-md-6 cst-col" *ngFor="let item of userApps" data-testid="app-card">
          <div class="col-wrapper c-pt justify-content-between">
            <div
              class="d-flex"
              [ngStyle]="{
                'flex-basis': item.name == 'POS' || item.name == 'TPMPortal' ? '20%' : '100%',
              }"
              style="flex-basis: 20%; height: 100%; align-items: center"
              (click)="redirectToModule(item.id)"
              (contextmenu)="onRightClick($event, item)"
              data-testid="app-main"
            >
              <div class="logo-url">
                <img width="36" [src]="item.appIcon" data-testid="app-logo" />
              </div>
              <h4 class="mb-0 ms-3" style="padding-block: 12px" data-testid="app-name">
                {{ item.name }}
              </h4>
            </div>
            <div
              *ngIf="
                item.name == 'TPMPortal' &&
                (canShowTpmAndroidAppDownloadOption || canShowTpmWindowAppDownloadOption)
              "
              style="flex-basis: 80%"
              data-testid="tpm-download-section"
            >
              <div class="d-flex justify-content-center">
                <ul class="d-flex download-apps mt-2 p-0 mb-0">
                  <li
                    class="d-flex justify-content-center align-items-center"
                    *ngIf="canShowTpmWindowAppDownloadOption"
                    data-testid="tpm-windows-download"
                  >
                    <a class="mx-2" data-testid="tpm-windows-link">
                      <div class="d-flex">
                        <div class="windows-icon">
                          <img
                            src="../../../../assets/images/Windows_logo.svg"
                            style="width: 30px; height: 30px"
                            alt=""
                          />
                        </div>
                      </div>
                    </a>
                    <div>
                      <p
                        class="download-timestamp"
                        *ngIf="
                          appVersions?.['tpm-windows']?.version &&
                          appVersions?.['tpm-windows']?.lastUpdated
                        "
                        data-testid="tpm-windows-updated"
                      >
                        <a
                          *ngIf="
                            appVersions?.['tpm-windows']?.version &&
                            appVersions?.['tpm-windows']?.lastUpdated
                          "
                          [href]="appVersions?.['tpm-windows']?.url"
                          class="mt-1 text-center download-link"
                          data-testid="tpm-windows-version"
                        >
                          <span class="text-success">Latest : </span>Download v{{
                            appVersions?.['tpm-windows']?.version
                          }}
                        </a>
                        Last updated:
                        {{ appVersions?.['tpm-windows']?.lastUpdated }}
                      </p>
                      <p
                        class="download-timestamp"
                        *ngIf="
                          appVersions?.['tpm-beta-windows']?.version &&
                          appVersions?.['tpm-beta-windows']?.lastUpdated
                        "
                        data-testid="tpm-windows-updated"
                      >
                        <a
                          *ngIf="
                            appVersions?.['tpm-beta-windows']?.version &&
                            appVersions?.['tpm-beta-windows']?.lastUpdated
                          "
                          [href]="appVersions?.['tpm-beta-windows']?.url"
                          class="mt-1 text-center download-link"
                          data-testid="tpm-windows-version"
                        >
                          <span class="text-success">Beta : </span>Download v{{
                            appVersions?.['tpm-beta-windows']?.version
                          }}
                        </a>
                        Last updated:
                        {{ appVersions?.['tpm-beta-windows']?.lastUpdated }}
                      </p>
                    </div>
                  </li>
                  <li
                    *ngIf="canShowTpmAndroidAppDownloadOption"
                    class="d-flex justify-content-center align-items-center ms-4"
                    data-testid="tpm-android-download"
                  >
                    <a
                      [href]="appVersions?.['tpm-android']?.url"
                      class="mx-2"
                      data-testid="tpm-android-link"
                    >
                      <div class="d-flex">
                        <div class="android-icon">
                          <img
                            src="../../../../assets/images/Android_robot.svg"
                            style="width: 30px; height: 30px"
                            alt=""
                          />
                        </div>
                      </div>
                    </a>
                    <div>
                      <p
                        *ngIf="
                          appVersions?.['tpm-android']?.version &&
                          appVersions?.['tpm-android']?.lastUpdated
                        "
                        class="download-timestamp"
                        data-testid="tpm-android-updated"
                      >
                        <a
                          *ngIf="
                            appVersions?.['tpm-android']?.version &&
                            appVersions?.['tpm-android']?.lastUpdated
                          "
                          [href]="appVersions?.['tpm-android']?.url"
                          class="mt-1 text-center download-link"
                          data-testid="tpm-android-version"
                        >
                          <span class="text-success">Latest : </span>Download v{{
                            appVersions?.['tpm-android']?.version
                          }}
                        </a>
                        Last updated:
                        {{ appVersions?.['tpm-android']?.lastUpdated }}
                      </p>
                      <p
                        *ngIf="
                          appVersions?.['tpm-beta-android']?.version &&
                          appVersions?.['tpm-beta-android']?.lastUpdated
                        "
                        class="download-timestamp"
                        data-testid="tpm-android-updated"
                      >
                        <a
                          *ngIf="
                            appVersions?.['tpm-beta-android']?.version &&
                            appVersions?.['tpm-beta-android']?.lastUpdated
                          "
                          [href]="appVersions?.['tpm-beta-android']?.url"
                          class="mt-1 text-center download-link"
                          data-testid="tpm-android-version"
                        >
                          <span class="text-success">Beta : </span>Download v{{
                            appVersions?.['tpm-beta-android']?.version
                          }}
                        </a>
                        Last updated:
                        {{ appVersions?.['tpm-beta-android']?.lastUpdated }}
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div
              *ngIf="
                item.name == 'POS' &&
                (canShowPosAndroidAppDownloadOption || canShowPosWindowAppDownloadOption)
              "
              style="flex-basis: 80%"
              data-testid="pos-download-section"
            >
              <div class="d-flex justify-content-center">
                <ul class="d-flex download-apps mt-2 p-0 mb-0">
                  <li
                    class="d-flex justify-content-center align-items-center"
                    *ngIf="canShowPosWindowAppDownloadOption"
                    data-testid="pos-windows-download"
                  >
                    <a data-testid="pos-windows-link" class="mx-2">
                      <div class="d-flex">
                        <div class="windows-icon">
                          <img
                            src="../../../../assets/images/Windows_logo.svg"
                            style="width: 30px; height: 30px"
                            alt=""
                          />
                        </div>
                      </div>
                    </a>
                    <div>
                      <p
                        *ngIf="
                          appVersions?.['pos-windows']?.version &&
                          appVersions?.['pos-windows']?.lastUpdated
                        "
                        class="download-timestamp"
                        data-testid="pos-windows-updated"
                      >
                        <a
                          *ngIf="
                            appVersions?.['pos-windows']?.version &&
                            appVersions?.['pos-windows']?.lastUpdated
                          "
                          [href]="appVersions?.['pos-windows']?.url"
                          class="d-flex mt-1 text-center download-link"
                          data-testid="pos-windows-version"
                        >
                          <span class="text-success">Latest : </span>Download v{{
                            appVersions?.['pos-windows']?.version
                          }}
                        </a>
                        Last updated:
                        {{ appVersions?.['pos-windows']?.lastUpdated }}
                      </p>
                      <p
                        *ngIf="
                          appVersions?.['pos-beta-windows']?.version &&
                          appVersions?.['pos-beta-windows']?.lastUpdated
                        "
                        class="download-timestamp"
                        data-testid="pos-windows-updated"
                      >
                        <a
                          *ngIf="
                            appVersions?.['pos-beta-windows']?.version &&
                            appVersions?.['pos-beta-windows']?.lastUpdated
                          "
                          [href]="appVersions?.['pos-beta-windows']?.url"
                          class="d-flex mt-1 text-center download-link"
                          data-testid="pos-windows-version"
                        >
                          <span class="text-success">Beta : </span>Download v{{
                            appVersions?.['pos-beta-windows']?.version
                          }}
                        </a>
                        Last updated:
                        {{ appVersions?.['pos-beta-windows']?.lastUpdated }}
                      </p>
                    </div>
                  </li>
                  <li
                    class="d-flex justify-content-center align-items-center ms-4"
                    *ngIf="canShowPosAndroidAppDownloadOption"
                    data-testid="pos-android-download"
                  >
                    <a class="mx-2" data-testid="pos-android-link">
                      <div class="d-flex">
                        <div class="android-icon">
                          <img
                            src="../../../../assets/images/Android_robot.svg"
                            style="width: 30px; height: 30px"
                            alt=""
                          />
                        </div>
                      </div>
                    </a>
                    <div>
                      <p
                        *ngIf="
                          appVersions?.['pos-android']?.version &&
                          appVersions?.['pos-android']?.lastUpdated
                        "
                        class="download-timestamp"
                        data-testid="pos-android-updated"
                      >
                        <a
                          *ngIf="
                            appVersions?.['pos-android']?.version &&
                            appVersions?.['pos-android']?.lastUpdated
                          "
                          [href]="appVersions?.['pos-android']?.url"
                          class="d-flex mt-1 text-center download-link"
                          data-testid="pos-android-version"
                        >
                          <span class="text-success">Latest : </span>Download v{{
                            appVersions?.['pos-android']?.version
                          }}
                        </a>
                        Last updated:
                        {{ appVersions?.['pos-android']?.lastUpdated }}
                      </p>
                      <p
                        *ngIf="
                          appVersions?.['pos-beta-android']?.version &&
                          appVersions?.['pos-beta-android']?.lastUpdated
                        "
                        class="download-timestamp"
                        data-testid="pos-android-updated"
                      >
                        <a
                          *ngIf="
                            appVersions?.['pos-beta-android']?.version &&
                            appVersions?.['pos-beta-android']?.lastUpdated
                          "
                          [href]="appVersions?.['pos-beta-android']?.url"
                          class="d-flex mt-1 text-center download-link"
                          data-testid="pos-android-version"
                        >
                          <span class="text-success">Beta : </span>Download v{{
                            appVersions?.['pos-beta-android']?.version
                          }}
                        </a>
                        Last updated:
                        {{ appVersions?.['pos-beta-android']?.lastUpdated }}
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="apps-section" *ngIf="isNotSufficientPermission" data-testid="no-permission-section">
      <div class="alert alert-warning" role="alert" data-testid="no-permission-alert">
        You do not have sufficient permission to access any apps.
      </div>
    </div>
  </div>
</div>
<div
  *ngIf="showContextMenu"
  [ngStyle]="{ top: contextMenuPosition.y, left: contextMenuPosition.x }"
  class="custom-context-menu"
  (click)="openInNewTab()"
  data-testid="context-menu"
>
  Open in new tab
</div>

<!-- Boostrap modal for showing warning -->
<button
  #defaultStoreWarning
  class="d-none"
  data-bs-target="#defaultStoreWarningModal"
  data-bs-toggle="modal"
  data-testid="default-store-warning-btn"
>
  fghfd
</button>
<div
  class="modal fade"
  id="defaultStoreWarningModal"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
  data-bs-backdrop="static"
  data-testid="default-store-warning-modal"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="custom-modal-header modal-header pb-0">
        <h5 class="mb-0" data-testid="default-store-modal-title">Default Store Not Configured!</h5>
      </div>
      <div class="custom-modal-body modal-body">
        <div class="modal-body-wraapper">
          <p style="font-size: 14px" data-testid="default-store-modal-desc">
            The system could not detect a default store assigned to your account ({{
              userObj.firstName + ' ' + userObj.lastName
            }}).
          </p>
          <p style="font-size: 14px">
            Please
            <a
              style="color: blue"
              data-bs-dismiss="modal"
              aria-label="Close"
              (click)="nevigateToDefaultStoreConfig()"
              data-testid="default-store-config-link"
              >click the link above</a
            >
            to configure your default store and proceed.
          </p>
          <p style="font-size: 14px">
            This setup is required to ensure proper access and functionality.
          </p>
        </div>
      </div>
      <div class="custom-modal-footer modal-footer pt-0">
        <button
          class="btn modal-btn"
          style="cursor: pointer"
          data-bs-dismiss="modal"
          aria-label="Close"
          data-testid="default-store-modal-close"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<div class="mobile-screen d-block d-lg-none">
  <div class="header-container details-header sticky-top d-lg-none">
    <button class="back-btn" data-testid="mobile-menu-btn">
      <img src="assets/images/navigation/menu-icon.svg" class="Menuicon" alt="Menu icon" />
    </button>
    <span class="header-title" data-testid="mobile-dashboard-title">Dashboard</span>
    <button class="back-btn" data-testid="mobile-notification-btn">
      <img
        src="/assets/images/navigation/Notification-Icon.svg"
        class="icon"
        alt="Notification icon"
      />
    </button>
  </div>
  <div class="home-page-wrapper">
    <!-- Welcome Header -->
    <div class="home-page-head">
      <span class="welcome-title" data-testid="mobile-welcome-title">
        Welcome back,&nbsp;
        <strong class="user-name" data-testid="mobile-user-name">{{
          userObj.firstName + ' ' + userObj.lastName
        }}</strong>
      </span>
    </div>

    <div class="home-page-content">
      <!-- Apps Section -->
      <div class="apps-section mb-5" *ngIf="userApps.length" data-testid="mobile-apps-section">
        <h6 class="fw-bold mb-3" data-testid="mobile-your-apps-title">Your apps</h6>

        <div class="apps-list">
          <!-- Loop each app -->
          <div
            class="app-card mb-4 p-3 shadow-sm border rounded-4"
            *ngFor="let item of userApps"
            data-testid="mobile-app-card"
          >
            <!-- App Header -->
            <div
              class="d-flex justify-content-center align-items-center mb-3"
              (click)="accessListerMobile(item.id)"
            >
              <div
                class="logo-url rounded-circle bg-light d-flex justify-content-center align-items-center"
                style="width: 40px; height: 40px"
              >
                <img width="24" [src]="item.appIcon" data-testid="mobile-app-logo" />
              </div>
              <h6 class="mb-0 ms-2 text-center fw-semibold" data-testid="mobile-app-name">
                {{ item.name }}
              </h6>
            </div>

            <!-- TPM Download options -->
            <ng-container *ngIf="item.name === 'TPMPortal'">
              <div
                class="download-card"
                *ngIf="canShowTpmWindowAppDownloadOption"
                data-testid="mobile-tpm-windows-download"
              >
                <div class="d-flex align-items-center justify-content-center card-wrapper">
                  <div class="d-flex align-items-center">
                    <img src="../../../../assets/images/Windows_logo.svg" width="22" height="22" />
                    <p class="ms-2 mb-0 small fw-medium">Windows App</p>
                  </div>
                  <div
                    *ngIf="
                      appVersions?.['tpm-windows']?.version &&
                      appVersions?.['tpm-windows']?.lastUpdated
                    "
                  >
                    <a
                      [href]="appVersions?.['tpm-windows']?.url"
                      class="download-link"
                      data-testid="mobile-tpm-windows-link"
                    >
                      <span class="text-success">Latest : </span>Download v{{
                        appVersions?.['tpm-windows']?.version
                      }}
                    </a>
                    <p class="download-timestamp" data-testid="mobile-tpm-windows-updated">
                      Last updated: {{ appVersions?.['tpm-windows']?.lastUpdated }}
                    </p>
                  </div>
                  <div
                    *ngIf="
                      appVersions?.['tpm-beta-windows']?.version &&
                      appVersions?.['tpm-beta-windows']?.lastUpdated
                    "
                  >
                    <a
                      [href]="appVersions?.['tpm-beta-windows']?.url"
                      class="download-link"
                      data-testid="mobile-tpm-windows-link"
                    >
                      <span class="text-success">Beta : </span>Download v{{
                        appVersions?.['tpm-beta-windows']?.version
                      }}
                    </a>
                    <p class="download-timestamp" data-testid="mobile-tpm-windows-updated">
                      Last updated: {{ appVersions?.['tpm-beta-windows']?.lastUpdated }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="download-card"
                *ngIf="canShowTpmAndroidAppDownloadOption"
                data-testid="mobile-tpm-android-download"
              >
                <div class="d-flex align-items-center justify-content-center card-wrapper">
                  <div class="d-flex align-items-center">
                    <img src="../../../../assets/images/Android_robot.svg" width="22" height="22" />
                    <p class="ms-2 mb-0 small fw-medium">Android App</p>
                  </div>
                  <div
                    *ngIf="
                      appVersions?.['tpm-android']?.version &&
                      appVersions?.['tpm-android']?.lastUpdated
                    "
                  >
                    <a
                      [href]="appVersions?.['tpm-android']?.url"
                      class="download-link"
                      data-testid="mobile-tpm-android-link"
                    >
                      <span class="text-success">Latest : </span>Download v{{
                        appVersions?.['tpm-android']?.version
                      }}
                    </a>
                    <p class="download-timestamp" data-testid="mobile-tpm-android-updated">
                      Last updated: {{ appVersions?.['tpm-android']?.lastUpdated }}
                    </p>
                  </div>
                  <div
                    *ngIf="
                      appVersions?.['tpm-beta-android']?.version &&
                      appVersions?.['tpm-beta-android']?.lastUpdated
                    "
                  >
                    <a
                      [href]="appVersions?.['tpm-beta-android']?.url"
                      class="download-link"
                      data-testid="mobile-tpm-android-link"
                    >
                      <span class="text-success">Beta : </span>Download v{{
                        appVersions?.['tpm-beta-android']?.version
                      }}
                    </a>
                    <p class="download-timestamp" data-testid="mobile-tpm-android-updated">
                      Last updated: {{ appVersions?.['tpm-beta-android']?.lastUpdated }}
                    </p>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- POS Download options -->
            <ng-container *ngIf="item.name === 'POS'">
              <div
                class="download-card"
                *ngIf="canShowPosWindowAppDownloadOption"
                data-testid="mobile-pos-windows-download"
              >
                <div class="d-flex align-items-center justify-content-center card-wrapper">
                  <div class="d-flex align-items-center">
                    <img src="../../../../assets/images/Windows_logo.svg" width="22" height="22" />
                    <p class="ms-2 mb-0 small fw-medium">Windows App</p>
                  </div>
                  <div
                    *ngIf="
                      appVersions?.['pos-windows']?.version &&
                      appVersions?.['pos-windows']?.lastUpdated
                    "
                  >
                    <a
                      [href]="appVersions?.['pos-windows']?.url"
                      class="download-link"
                      data-testid="mobile-pos-windows-link"
                    >
                      <span class="text-success">Latest : </span>Download v{{
                        appVersions?.['pos-windows']?.version
                      }}
                    </a>
                    <p class="download-timestamp" data-testid="mobile-pos-windows-updated">
                      Last updated: {{ appVersions?.['pos-windows']?.lastUpdated }}
                    </p>
                  </div>
                  <div
                    *ngIf="
                      appVersions?.['pos-beta-windows']?.version &&
                      appVersions?.['pos-beta-windows']?.lastUpdated
                    "
                  >
                    <a
                      [href]="appVersions?.['pos-beta-windows']?.url"
                      class="download-link"
                      data-testid="mobile-pos-windows-link"
                    >
                      <span class="text-success">Beta : </span>Download v{{
                        appVersions?.['pos-beta-windows']?.version
                      }}
                    </a>
                    <p class="download-timestamp" data-testid="mobile-pos-windows-updated">
                      Last updated: {{ appVersions?.['pos-beta-windows']?.lastUpdated }}
                    </p>
                  </div>
                </div>
              </div>

              <div
                class="download-card"
                *ngIf="canShowPosAndroidAppDownloadOption"
                data-testid="mobile-pos-android-download"
              >
                <div class="d-flex align-items-center justify-content-center card-wrapper">
                  <div class="d-flex align-items-center">
                    <img src="../../../../assets/images/Android_robot.svg" width="22" height="22" />
                    <p class="ms-2 mb-0 small fw-medium">Android App</p>
                  </div>
                  <div
                    *ngIf="
                      appVersions?.['pos-android']?.version &&
                      appVersions?.['pos-android']?.lastUpdated
                    "
                  >
                    <a
                      [href]="appVersions?.['pos-android']?.url"
                      class="download-link"
                      data-testid="mobile-pos-android-link"
                    >
                      <span class="text-success">Latest : </span>Download v{{
                        appVersions?.['pos-android']?.version
                      }}
                    </a>
                    <p class="download-timestamp" data-testid="mobile-pos-android-updated">
                      Last updated: {{ appVersions?.['pos-android']?.lastUpdated }}
                    </p>
                  </div>
                  <div
                    *ngIf="
                      appVersions?.['pos-beta-android']?.version &&
                      appVersions?.['pos-beta-android']?.lastUpdated
                    "
                  >
                    <a
                      [href]="appVersions?.['pos-beta-android']?.url"
                      class="download-link"
                      data-testid="mobile-pos-android-link"
                    >
                      <span class="text-success">Beta : </span>Download v{{
                        appVersions?.['pos-beta-android']?.version
                      }}
                    </a>
                    <p class="download-timestamp" data-testid="mobile-pos-android-updated">
                      Last updated: {{ appVersions?.['pos-beta-android']?.lastUpdated }}
                    </p>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- IMS (no downloads) -->
            <ng-container *ngIf="item.name === 'IMS'">
              <div class="download-card text-center" data-testid="mobile-ims-no-download">
                <p class="mb-0 small text-muted">No downloadable apps available</p>
              </div>
            </ng-container>
          </div>
        </div>
        <div
          class="app-card d-flex justify-content-center align-items-center border rounded-4"
          (click)="accessIMS()"
          *ngIf="canShowImsOption"
          data-testid="mobile-ims-access"
        >
          <div class="ims-access d-flex">
            <img src="assets/images/company-management/ims_color_icon.svg" alt="" />
            <a>
              <h6 class="mb-0 ms-2 text-center fw-semibold">IMS</h6>
            </a>
          </div>
        </div>
      </div>

      <!-- No Permission -->
      <div
        class="apps-section"
        *ngIf="isNotSufficientPermission"
        data-testid="mobile-no-permission-section"
      >
        <div
          class="alert alert-warning small"
          role="alert"
          data-testid="mobile-no-permission-alert"
        >
          You do not have sufficient permission to access any apps.
        </div>
      </div>
    </div>
  </div>
</div>
